/**
 * <pdp-produto>: comportamento da seção sections/pdp-produto.liquid.
 * Galeria, escolha de kit, quantidade, escada (frete fixo / 5% / 10%), adicionar ao carrinho
 * (abre a gaveta pelo mesmo evento do tema), produtos que combinam, ativos, composição,
 * avaliações e menu de seções.
 */
const money = (c) =>
  'R$ ' + Math.floor(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + String(Math.round(c % 100)).padStart(2, '0');

class PdpProduto extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    this.qty = 1;
    try {
      this.tiers = JSON.parse(this.dataset.tiers || '[]').filter((t) => t.amount > 0);
    } catch (e) {
      this.tiers = [];
    }
    this.kit = this.querySelector('[data-pdp-kit].is-selected') || this.querySelector('[data-pdp-solo]');
    this.#bindGallery();
    this.#bindBuy();
    this.#bindContent();
    this.#update();
  }

  /* ---------- Galeria ---------- */
  #bindGallery() {
    const slides = [...this.querySelectorAll('[data-pdp-slide]')];
    const thumbs = [...this.querySelectorAll('[data-pdp-thumb]')];
    if (slides.length < 2) return;
    let current = 0;
    const show = (i) => {
      current = (i + slides.length) % slides.length;
      slides.forEach((s, k) => (s.hidden = k !== current));
      thumbs.forEach((t, k) => {
        t.classList.toggle('is-active', k === current);
        t.setAttribute('aria-current', k === current ? 'true' : 'false');
      });
    };
    thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
    this.querySelector('[data-pdp-prev]')?.addEventListener('click', () => show(current - 1));
    this.querySelector('[data-pdp-next]')?.addEventListener('click', () => show(current + 1));
    // Arrastar no celular
    const stage = this.querySelector('.pdp__stage');
    let x0 = null;
    stage?.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
    stage?.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* ---------- Compra ---------- */
  #bindBuy() {
    this.querySelectorAll('[data-pdp-kit]').forEach((btn) =>
      btn.addEventListener('click', () => {
        this.querySelectorAll('[data-pdp-kit]').forEach((b) => {
          b.classList.toggle('is-selected', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        this.kit = btn;
        this.#update();
      })
    );
    this.querySelectorAll('[data-pdp-qty]').forEach((btn) =>
      btn.addEventListener('click', () => {
        this.qty = Math.min(10, Math.max(1, this.qty + Number(btn.dataset.pdpQty)));
        this.#update();
      })
    );
    this.querySelectorAll('[data-pdp-add]').forEach((btn) => btn.addEventListener('click', () => this.#addMain(btn)));
    this.querySelectorAll('[data-pdp-combo]').forEach((btn) =>
      btn.addEventListener('click', async () => {
        if (btn.classList.contains('is-done')) return;
        btn.disabled = true;
        const ok = await this.#add([{ id: Number(btn.dataset.pdpCombo), quantity: 1 }], 'pdp-combo');
        btn.disabled = false;
        if (ok) {
          btn.classList.add('is-done');
          btn.textContent = 'Adicionado';
        }
      })
    );
  }

  #state() {
    const price = Number(this.kit?.dataset.price || 0);
    const compare = Number(this.kit?.dataset.compare || 0);
    const total = price * this.qty;
    const reached = this.tiers.filter((t) => total >= t.amount);
    const next = this.tiers.find((t) => total < t.amount);
    const pct = reached.reduce((p, t) => Math.max(p, t.pct || 0), 0);
    return { price, compare, total, reached, next, pct };
  }

  #update() {
    const { price, compare, total, reached, next, pct } = this.#state();
    if (!this.kit) return;
    const set = (sel, txt) => this.querySelectorAll(sel).forEach((el) => (el.textContent = txt));

    // Com degrau de desconto da escada atingido, o preço em destaque é o que a cliente paga no carrinho
    // e o preço cheio aparece riscado.
    const shown = pct ? Math.round((price * (100 - pct)) / 100) : price;
    const was = pct ? Math.max(compare, price) : compare;
    set('[data-pdp-price]', money(shown));
    const cmp = this.querySelector('[data-pdp-compare]');
    if (cmp) {
      cmp.hidden = !(was > shown);
      cmp.textContent = was > shown ? money(was) : '';
    }
    const n = Math.min(Math.floor(shown / 5000), 3);
    set('[data-pdp-inst]', n >= 2 ? `ou ${n}x de ${money(Math.floor(shown / n))} sem juros` : '');
    set('[data-pdp-qty-value]', String(this.qty));

    const finalTotal = Math.round((total * (100 - pct)) / 100);
    const addBtn = this.querySelector('.pdp__hero [data-pdp-add]');
    if (addBtn && !addBtn.disabled) set('[data-pdp-add-label]', 'Adicionar · ' + money(finalTotal));
    set('[data-pdp-sticky-price]', money(finalTotal));

    // Escada
    const text = this.querySelector('[data-pdp-escada-text]');
    const fill = this.querySelector('[data-pdp-escada-fill]');
    if (!text || !this.tiers.length) return;
    const won = [];
    if (reached.length) won.push(this.tiers[0].label);
    if (pct) won.push(reached.filter((t) => t.pct).pop().label);
    const wonTxt = won.join(' e ');
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
    if (next && !reached.length) {
      text.innerHTML = `Faltam ${money(next.amount - total)} para ganhar <strong>${esc(next.label)}</strong>.`;
    } else if (next) {
      text.innerHTML = `Com este pedido você ganha <strong>${esc(wonTxt)}</strong>. Faltam ${money(next.amount - total)} para ${esc(next.label)}.`;
    } else {
      text.innerHTML = `Você ganha <strong>${esc(wonTxt)}</strong>.`;
    }
    let w = 0;
    let prev = 0;
    const step = 100 / this.tiers.length;
    for (const t of this.tiers) {
      if (total >= t.amount) {
        w += step;
        prev = t.amount;
      } else {
        w += ((total - prev) / (t.amount - prev)) * step;
        break;
      }
    }
    if (fill) fill.style.width = Math.min(100, Math.max(0, w)) + '%';
  }

  async #addMain(btn) {
    if (!this.kit) return;
    const items = [{ id: Number(this.kit.dataset.variant), quantity: this.qty }];
    this.querySelectorAll('[data-pdp-add]').forEach((b) => {
      b.disabled = true;
      b.setAttribute('aria-busy', 'true');
    });
    const ok = await this.#add(items, 'pdp-produto');
    this.querySelectorAll('[data-pdp-add]').forEach((b) => {
      b.disabled = false;
      b.removeAttribute('aria-busy');
    });
    if (ok && window.track) {
      const { total } = this.#state();
      window.track('pdp_added', { name: this.kit.dataset.name, quantity: this.qty, value: total / 100, currency: 'BRL' });
    }
  }

  async #add(items, source) {
    const err = this.querySelector('[data-pdp-error]');
    if (err) err.hidden = true;
    const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: ids.join(',') || undefined }),
      });
      const added = await r.json();
      if (!r.ok) throw new Error(added.description || added.message || 'add_failed');
      const cart = await (await fetch('/cart.js')).json();
      let sections = added.sections;
      if (!sections && ids.length) sections = (await (await fetch('?sections=' + ids.join(','))).json());
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: this.dataset.sectionId, data: { source, itemCount: cart.item_count, sections } },
        })
      );
      document.dispatchEvent(new CustomEvent('cart:add', { detail: { items, cart } }));
      document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart } }));
      return true;
    } catch (e) {
      console.error('pdp-produto: erro ao adicionar', e);
      if (err) {
        err.textContent = 'Não foi possível adicionar ao carrinho. ' + (e.message && e.message !== 'add_failed' ? e.message : 'Tente novamente.');
        err.hidden = false;
      }
      return false;
    }
  }

  /* ---------- Conteúdo ---------- */
  #bindContent() {
    const actives = [...this.querySelectorAll('[data-pdp-active]')];
    actives.forEach((a) =>
      a.addEventListener('click', () => {
        const open = !a.classList.contains('is-open');
        actives.forEach((o) => {
          o.classList.toggle('is-open', o === a && open);
          o.setAttribute('aria-expanded', o === a && open ? 'true' : 'false');
        });
      })
    );

    const inci = this.querySelector('[data-pdp-inci]');
    inci?.addEventListener('click', () => {
      const p = inci.nextElementSibling;
      const open = p.hidden;
      p.hidden = !open;
      inci.setAttribute('aria-expanded', String(open));
      inci.textContent = open ? 'Ocultar composição completa' : 'Ver composição completa';
    });

    const more = this.querySelector('[data-pdp-more]');
    more?.addEventListener('click', async () => {
      more.disabled = true;
      more.textContent = 'Carregando avaliações…';
      try {
        await this.loadAllReviews();
      } catch (e) {
        // sem rede ou Judge.me fora: mostra ao menos as que já vieram na página
      }
      this.querySelectorAll('[data-pdp-more-item]').forEach((r) => (r.hidden = false));
      more.remove();
    });

    const write = this.querySelector('[data-pdp-write]');
    write?.addEventListener('click', () => {
      const box = this.querySelector('[data-pdp-judgeme]');
      if (!box) return;
      box.hidden = false;
      const form = box.querySelector('.jdgm-write-rev-link, .jdgm-rev-widg__summary a');
      if (form) form.click();
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Menu de seções: marca a seção visível
    const links = [...this.querySelectorAll('[data-pdp-anchor]')];
    const targets = links.map((l) => this.querySelector(l.getAttribute('href'))).filter(Boolean);
    if (targets.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            links.forEach((l) => {
              const on = l.getAttribute('href') === '#' + e.target.id;
              l.classList.toggle('is-active', on);
              if (on) l.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
            });
          });
        },
        { rootMargin: '-45% 0px -50% 0px' }
      );
      targets.forEach((t) => io.observe(t));
    }
  }

  // O metafield do Judge.me traz só as primeiras avaliações de cada produto. Quando há mais,
  // busca todas na API pública do widget e redesenha a lista, da melhor para a pior nota.
  async loadAllReviews() {
    const list = this.querySelector('[data-pdp-reviews]');
    if (!list) return;
    const sources = JSON.parse(list.dataset.pdpReviews || '[]');
    const shown = list.querySelectorAll('.pdp__review').length;
    const total = sources.reduce((s, x) => s + (x.total || 0), 0);
    if (!sources.length || shown >= total) return;

    const shop = (window.Shopify && window.Shopify.shop) || 'narte-hair.myshopify.com';
    const fetchProduct = async (src) => {
      const out = [];
      for (let page = 1; page <= 20; page++) {
        const url = `https://api.judge.me/reviews/reviews_for_widget?url=${shop}&shop_domain=${shop}&platform=shopify&per_page=30&page=${page}&product_id=${src.id}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('judgeme ' + res.status);
        const data = await res.json();
        (data.reviews || []).forEach((r) => out.push({ ...r, _name: src.name || '' }));
        if (!data.pagination || page >= data.pagination.total_pages) break;
      }
      return out;
    };
    const groups = await Promise.all(sources.map(fetchProduct));
    const all = groups.flat();
    if (all.length <= shown) return;

    // estável: na mesma nota, mantém a ordem do Judge.me e a ordem dos produtos
    const sorted = all.map((r, i) => ({ r, i })).sort((a, b) => (b.r.rating - a.r.rating) || (a.i - b.i)).map((x) => x.r);
    const visible = Number(list.dataset.pdpVisible || 3);
    const text = (html) => {
      const d = document.createElement('div');
      d.innerHTML = html || '';
      return d.textContent.trim();
    };
    const el = (tag, cls, txt) => {
      const e = document.createElement(tag);
      if (cls) e.className = cls;
      if (txt != null) e.textContent = txt;
      return e;
    };
    const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : '');
    const frag = document.createDocumentFragment();
    sorted.forEach((r, n) => {
      const art = el('article', 'pdp__review');
      if (n >= visible) {
        art.hidden = true;
        art.setAttribute('data-pdp-more-item', '');
      }
      const body = el('div', 'pdp__review-body');
      const head = el('div', 'pdp__review-head');
      head.append(el('span', 'pdp__review-name', cap(r.reviewer_name)));
      if (r.verified_buyer) head.append(el('span', 'pdp__verified', 'Compra verificada'));
      if (r._name) head.append(el('span', 'pdp__review-product', r._name));
      const full = Math.min(5, Math.round(r.rating));
      const stars = el('span', 'pdp__stars', '★'.repeat(full) + '☆'.repeat(5 - full));
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', `${r.rating} de 5 estrelas`);
      body.append(head, stars, el('p', null, text(r.body_html)));
      art.append(body);
      const pic = r.pictures_urls && r.pictures_urls[0];
      if (pic && pic.compact) {
        const img = el('img', 'pdp__review-photo');
        img.src = pic.compact;
        img.alt = `Foto enviada por ${r.reviewer_name || ''}`;
        img.width = 88;
        img.height = 88;
        img.loading = 'lazy';
        art.append(img);
      }
      frag.append(art);
    });
    list.querySelectorAll('.pdp__review').forEach((a) => a.remove());
    list.prepend(frag);
  }
}

if (!customElements.get('pdp-produto')) customElements.define('pdp-produto', PdpProduto);
